import { serverBus } from '@/main'
import SessionManager from '@/Manager/Session.manager'
import Global from '@/scripts/Global'
import DOMManager from '@/Manager/DOM.manager'
import VueSignals from '@/scripts/VueSignals';
export default {
    name: 'ChannelList',
    data (){
      return {
        showAvailableContent: false,
        isEmpty: false,
        channels: Array(),
      }
    }
    ,
    mounted(){     
        this.channels =  SessionManager.getChannels()      
        serverBus.$on(VueSignals.KEYBOARD_SHOW_CHANNEL_LIST, (user_name) => {
            this.showAvailableContent = true
        })

        if(this.channels == 0){
            this.isEmpty = true
        }
    },
}
